import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

function CodingTest() {
  const { applicationId } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [codingTest, setCodingTest] = useState(null);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  // =========================
  // FETCH CODING TEST
  // =========================
  useEffect(() => {
    async function fetchTest() {
      try {
        const res = await axios.get(
            `/api/coding-test/${applicationId}`
        );

        setCodingTest(res.data);

        if (res.data?.candidate_code) {
          setCode(res.data.candidate_code);
        }
      } catch (err) {
        console.error("Failed to load coding test:", err);
        setError("Failed to load coding test.");
      } finally {
        setLoading(false);
      }
    }

    fetchTest();
  }, [applicationId]);

  // =========================
  // SUBMIT TEST
  // =========================
  async function handleSubmit() {
    try {
      setSubmitting(true);

      await axios.post(
          `/api/coding-test/${applicationId}/submit`,
          {
            code,
          }
      );

      alert("✅ Coding test submitted successfully!");

      navigate("/candidate/dashboard");
    } catch (err) {
      console.error("Submit failed:", err);
      setError("Failed to submit coding test.");
    } finally {
      setSubmitting(false);
    }
  }

  // =========================
  // LOADING
  // =========================
  if (loading) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
          <CircularProgress />
        </Box>
    );
  }

  if (!codingTest) {
    return (
        <Container sx={{ py: 4 }}>
          <Alert severity="error">Coding test not found.</Alert>
        </Container>
    );
  }

  return (
      <Container sx={{ py: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom>
            Coding Test
          </Typography>

          {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
          )}

          <Alert severity="info" sx={{ mb: 3 }}>
            Complete the coding challenge below. Make sure to submit before
            time expires.
          </Alert>

          {/* QUESTION */}
          <Typography variant="h6" gutterBottom>
            Problem:
          </Typography>

          <Paper
              variant="outlined"
              sx={{
                p: 2,
                bgcolor: "#f9f9f9",
                whiteSpace: "pre-wrap",
                mb: 3,
              }}
          >
            {codingTest.question || "No question provided"}
          </Paper>

          {/* CODE EDITOR */}
          <TextField
              fullWidth
              multiline
              rows={16}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="// Write your code here"
              sx={{
                mt: 2,
                fontFamily: "monospace",
                "& textarea": { fontFamily: "monospace" },
              }}
          />

          {/* SUBMIT BUTTON */}
          <Box sx={{ mt: 3 }}>
            <Button
                variant="contained"
                size="large"
                onClick={handleSubmit}
                disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit Test"}
            </Button>
          </Box>
        </Paper>
      </Container>
  );
}

export default CodingTest;
